import { RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import {
  INACTIVE_LEGAL_ENTITY,
  USER_LEGAL_ENTITIES_REQUIRED,
} from '@webapp/platform/iam/business-logic/interfaces/IUserRepository'

const LEGAL_ENTITY_ASSIGNMENT_ERROR_CODES = new Set<string>([
  USER_LEGAL_ENTITIES_REQUIRED,
  INACTIVE_LEGAL_ENTITY,
])

interface ErrorsWithCodesResponse {
  errors_with_codes?: { code: string }[]
}

export const getLegalEntityAssignmentErrorCode = (
  err: unknown
): Nullable<string> => {
  if (!(err instanceof RepoError)) return null

  const codes = [
    ...((err.response as ErrorsWithCodesResponse | undefined)
      ?.errors_with_codes ?? []),
    { code: err.code },
  ].map((error) => error.code)

  return (
    codes.find((code) => LEGAL_ENTITY_ASSIGNMENT_ERROR_CODES.has(code)) ?? null
  )
}
